// 背景貼圖載入 — 沿用 Unity Art/Bg/ 資源：bg_mg（主遊戲）/ bg_fg（Free Game）。

import { Assets, type Texture } from 'pixi.js'

export type BackgroundKey = 'mg' | 'fg'

const URLS: Readonly<Record<BackgroundKey, string>> = {
  mg: '/images/bg/bg_mg.webp',
  fg: '/images/bg/bg_fg.webp',
}

let textureCache: ReadonlyMap<BackgroundKey, Texture> | null = null

export async function loadBackgroundTextures(): Promise<ReadonlyMap<BackgroundKey, Texture>> {
  if (textureCache !== null) return textureCache

  const entries = await Promise.all(
    (Object.entries(URLS) as Array<[BackgroundKey, string]>).map(async ([key, url]) => {
      const texture = await Assets.load<Texture>(url)
      return [key, texture] as const
    }),
  )
  textureCache = new Map(entries)
  return textureCache
}

export function getBackgroundTexture(key: BackgroundKey): Texture {
  if (textureCache === null) {
    throw new Error('背景貼圖尚未載入，請先呼叫 loadBackgroundTextures()')
  }
  const texture = textureCache.get(key)
  if (texture === undefined) {
    throw new Error(`找不到背景貼圖：${key}`)
  }
  return texture
}
